import type {
  TaxonomyField,
  TaxonomyRule,
  TaxonomySettings,
  TaxonomyVersion,
} from '@/entities/taxonomy';

/** The editable shape of a draft version, as the builder holds it on screen. */
export interface DraftState {
  name: string;
  description: string;
  market: string[];
  platform: string[];
  fields: TaxonomyField[];
  rules: TaxonomyRule[];
  settings: TaxonomySettings;
}

/**
 * The version a taxonomy is currently pointed at, falling back to the highest
 * version number when nothing is pinned.
 *
 * Shared rather than local because autosave reads it off a save RESPONSE to
 * advance the revision it sends next, while the page reads it off the query — and
 * the two must agree about which version is the head.
 */
export function resolveHead(
  versions: TaxonomyVersion[],
  currentVersionId: string | null,
): TaxonomyVersion | undefined {
  if (versions.length === 0) return undefined;
  return (
    (currentVersionId && versions.find((v) => v.id === currentVersionId)) ||
    versions.reduce((a, b) => (b.versionNumber > a.versionNumber ? b : a))
  );
}
